module.exports = __webpack_public_path__ + "static/image/temp/main/visual_1_1920x900.jpeg?64bb7b4f";